import React, {useContext, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import GridComponent from '../../../../../components/slides/form/part/grid';
import {DeviceType} from '../../../../../incase-domain/common/DeviceType.enum';
import {presUpdateSpinnerSelector} from '../../../../../store/selectors/spinner.selector';
import {selectedSlideSelector} from '../../../../../store/selectors/slide.selectors';
import {setHighlightedElementIndex, updateScale} from '../../../../../store/actions/slide';
import {SlideRefContext} from '../../../../../context/SlideRefContext';
import {usePresScaleContext} from '../../../../../context/PresScaleContext';
import {setSidePanelContentAction} from '../../../../../store/actions/grid';
import {SidePanelContent} from '../../../../../store/actions/types/grid.types';
import {useSlideClickHandler} from '../../../../../utils/hooks/useHandleSlideClick';
import useSlideDropHandlers from './useSlideDropHandlers';
import {useSlideBackground} from '../../../../../hooks/useSlideBackground';
import Elements from '../../../../../components/slides/form/elements/Elements';

const CELL_WIDTH = 20;
const CELL_HEIGHT = 20;
export const SLIDE_WORKSPACE_DESKTOP = 'slide-workspace';

function SlideContainer(): JSX.Element {
    const dispatch = useDispatch();
    const {slideRef} = useContext(SlideRefContext);
    const slide = useSelector(selectedSlideSelector);
    const presUpdateSpinner = useSelector(presUpdateSpinnerSelector);
    const handleSlideClick = useSlideClickHandler();
    const {onDragEnterOver, onDrop} = useSlideDropHandlers();
    const {scale, slideSize, workspaceSize} = usePresScaleContext();
    const {effectiveBackgroundColor, effectiveBackgroundImage} = useSlideBackground();

    useEffect(() => {
        dispatch(updateScale(scale));
    }, [dispatch, scale]);

    return (
        <div
            key={String(presUpdateSpinner)}
            className="p-presEdit__slide"
            style={{
                height: `${slideSize.height}px`,
                width: `${slideSize.width}px`,
            }}
            onClick={(e) => handleSlideClick(e, SLIDE_WORKSPACE_DESKTOP)}
        >
            <div
                id={SLIDE_WORKSPACE_DESKTOP}
                ref={slideRef}
                style={{
                    backgroundColor: effectiveBackgroundColor,
                    backgroundImage: `url('${effectiveBackgroundImage}')`,
                    backgroundSize: '100% 100%',
                    width: `${workspaceSize.width}px`,
                    height: `${workspaceSize.height}px`,
                    transform: `scale(${scale})`,
                    transformOrigin: 'top left',
                }}
                onDragEnter={onDragEnterOver}
                onDragOver={onDragEnterOver}
                onDrop={onDrop}
            >
                <div onClick={(e) => handleSlideClick(e, SLIDE_WORKSPACE_DESKTOP, true)}>
                    <GridComponent cellWidth={CELL_WIDTH} cellHeight={CELL_HEIGHT} />
                </div>

                <Elements
                    device={DeviceType.DESKTOP}
                    slideId={slide._id}
                    elements={slide.elements || []}
                    onOptions={(id: string, silent?: boolean) => {
                        const index = slide.elements.findIndex((el) => el.id === id);
                        dispatch(setHighlightedElementIndex(index));

                        if (!silent) {
                            dispatch(setSidePanelContentAction(SidePanelContent.HIGHLIGHTED_ELEMENT));
                        }
                    }}
                    cellWidth={CELL_WIDTH}
                    cellHeight={CELL_HEIGHT}
                />
            </div>
        </div>
    );
}

export default SlideContainer;
